// https://webpack.js.org/guides/dependency-management/#requirecontext
const reimburseapiFiles = require.context('./reimburseapi', true, /\.js$/)
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const reimburseapi = reimburseapiFiles.keys().reduce((reimburseapi, apiPath) => {
    // set './app.js' => 'app'
    const apiName = apiPath.replace(/^\.\/(.*)\.\w+$/, '$1')

    const value = reimburseapiFiles(apiPath)

    reimburseapi[apiName] = value.default

    return reimburseapi
}, {})
export default reimburseapi